import { render, staticRenderFns } from "./DestinationList.vue?vue&type=template&id=610e17cc&scoped=true"
import script from "./DestinationList.vue?vue&type=script&lang=js"
export * from "./DestinationList.vue?vue&type=script&lang=js"
import style0 from "./DestinationList.vue?vue&type=style&index=0&id=610e17cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e17cc",
  null
  
)

export default component.exports